<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />
    <br aria-hidden="true" />

    <div class="map-container-new">
      <div class="map-text-bubble-new bring-out-z">
        <div>
          <br aria-hidden="true" />
          <br aria-hidden="true" />
          <p v-html="LG('SS_paragraph1')"></p>
          <br aria-hidden="true" />
          <div class="centered-element">
            <b-button class="funky-shape" v-on:click="onNextButtonClicked()">{{ LG("G_continueLabel") }}</b-button>
          </div>
          <br aria-hidden="true" />
        </div>
      </div>
      <div class="bg-tutorial-image-container">
        <div class="bg-tutorial-image" :style="{ backgroundImage: 'url(' + getBackgroundImage() + ')' }">
          <div class="tutorial-screen-overlay" :style="{ backgroundImage: 'url(' + blurredOverlay + ')' }"></div>
        </div>
      </div>

      <!--<div class="bg-tutorial-image-container center-image">
                <img :src="getBackgroundImage()" class="bg-tutorial-image img-fluid" alt="">
                <div class="tutorial-screen-overlay"></div>
      </div>-->
    </div>

    <!--<div class="row">
        <div class="col-sm-5">
    <div class="bg-tutorial-area">-->
    <!--<br />
    <h4 v-html="LG('SA_heading1')"></h4>-->
    <!--<br />
        <br />
    <p v-html="LG('SS_paragraph1')"></p>-->
    <!--<p v-html="LG('SS_paragraph2')"></p>
    <br />-->
    <!--<br />
                    <div class="centered-element">
                        <b-button class="funky-shape" v-on:click="onNextButtonClicked()">{{LG('G_continueLabel')}}</b-button>
                    </div>
                    <br />
                </div>
            </div>
            <div class="col-sm bg-tutorial-image-container">
                <img :src="getBackgroundImage()" class="bg-tutorial-image img-fluid" alt="">
            </div>
    </div>-->
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <AudioPlayer id="id-tutorial-audio" :url="introAudio"></AudioPlayer>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    ProgressBars,
    AudioPlayer,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      blurredOverlay: require("@/assets/menus/popups/popup_bg_play.png"),

      // Arrays
      backgrounds: [
        {
          image: require("../assets/scenes/scene1/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene2/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene3/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene4/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene5/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene6/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene7/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene8/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene9/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene10/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene11/MES_Background.png"),
        },
        {
          image: require("../assets/scenes/scene12/MES_Background.png"),
        },
      ],

      // Variables

      // Audio
      introAudio: "/audio/partager/partager_tutorial.mp3",
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);
  },
  methods: {
    getBackgroundImage() {
      //return this.animatedImage;

      var situation = this.getCurrentSituation();
      if (situation == -1) {
        situation = 0;
      }
      return this.backgrounds[situation].image;
    },
    onNextButtonClicked() {
      this.$router.push(`/${this.areaName}/${this.situationName}/jouer`);
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");
@import url("https://fonts.googleapis.com/css?family=Nunito");

.bg-tutorial-area {
  background-color: transparent;
  color: white;
  font-family: "Poppins";
  font-size: 17px;
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding: 25px;
  position: relative;
  padding: 60px;
  text-align: left;
}

.bring-out-z {
  z-index: 2 !important;
}

.tutorial-screen-overlay {
  backdrop-filter: blur(3px);
  border-radius: 35px;
  z-index: 1;
  background-color: transparent;
  min-height: 700px;
  height: 100%;
  width: 100%;
}

.bg-tutorial-image-container {
  height: 600px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.bg-tutorial-image {
  border: 15px solid white;
  border-radius: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 75%;
  background-repeat: no-repeat;
  background-size: cover;
  /*filter: grayscale(100%);*/
}

h1.page-title {
  font-size: 32px !important;
  font-family: "Poppins" !important;
  font-weight: bold !important;
}

h2.page-subtitle {
  font-size: 28px !important;
  font-family: "Handlee" !important;
  font-weight: bold !important;
}

@media only screen and (max-width: 1300px) {
  .bg-tutorial-image {
    width: 100%;
    max-width: 1000px;
  }

  .bg-tutorial-image-container {
    padding-top: 50px;
  }
}
</style>
